import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const missingSupabaseVars = [
  !supabaseUrl ? "REACT_APP_SUPABASE_URL" : null,
  !supabaseAnonKey ? "REACT_APP_SUPABASE_ANON_KEY" : null,
].filter(Boolean);

export const isSupabaseConfigured = missingSupabaseVars.length === 0;
export const supabaseConfigError = isSupabaseConfigured
  ? ""
  : `Missing required environment variable${missingSupabaseVars.length > 1 ? "s" : ""}: ${missingSupabaseVars.join(", ")}`;

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
